import { SubParticipantPosition } from '@collector/sportsapi-client-legacy'
import { SubParticipant } from '@collector/sportsapi-types'

import { PlayersConfig } from '../../configuration'

// helpers
export function isFirstLineupPosition(
  position: SubParticipantPosition,
): boolean {
  return [
    SubParticipantPosition.FirstLineup,
    SubParticipantPosition.Goalkeeper,
  ].includes(position)
}

function isBenchPosition(position: SubParticipantPosition): boolean {
  return position === SubParticipantPosition.Bench
}

// config
function isPlayer(subParticipant: SubParticipant): boolean {
  return (
    isFirstLineupPosition(subParticipant.position) ||
    isBenchPosition(subParticipant.position)
  )
}

function isPriorityPosition(
  subParticipantPosition: SubParticipantPosition,
): boolean {
  return subParticipantPosition === SubParticipantPosition.Goalkeeper
}

export const playersConfig: PlayersConfig = {
  isPlayer,
  isPriorityPosition,
}
